import * as React from "react";
import * as ReactDOM from "react-dom";
import AreaOfDamageReact from "./AreaOfDamageReact";
import { ReactComponent } from "lexisnexis-form";
import settingsForm from "./AreaOfDamage.settingsForm.js";
import * as defaultArea from "./areasOfImpact/defaultArea.js";
import { IImpactSettings } from "./business-objects/AreaOfDamageOptions";

export default class AreaOfDamage extends ReactComponent {
  private component: any;
  private dataValue: any;
  private updateValue: any;
  private id: string;
  private on: Function;
  private vehicleType: string;
  private element: any;
  private areaOfDamageBaseSchema: IImpactSettings[];

  static schema(...extend) {
    const schema = ReactComponent.schema(
      {
        type: "areaOfDamage",
        key: "areaOfDamage",
        label: "Area Of Damage"
      },
      ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: "Area Of Damage",
      group: "advanced",
      icon: "car",
      weight: -10,
      schema: AreaOfDamage.schema()
    };
  }

  static editForm = settingsForm;

  init() {
    this.on("change", event => {
      if (event.changed && event.changed.component && event.changed.component.key === this.component.compToMatch) {
        this.vehicleType = event.changed.value;

        this.detachReact(this.element);
        this.attachReact(this.element);
      }
    });
  }

  attachReact(element) {
    this.element = element;
    this.areaOfDamageBaseSchema = defaultArea.defaultValues();
    return ReactDOM.render(
      <AreaOfDamageReact
        id={this.id}
        component={this.component}
        value={this.dataValue}
        onChange={this.updateValue}
        vehicleType={this.vehicleType}
        areaOfDamageBaseSchema={this.areaOfDamageBaseSchema}
      />,
      element
    );
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
